export interface MenuItem {
  id: string;
  label: string;
  translation?: string;
  type?:
  | "muteSound"
  | "r2t"
  | "lang"
  | "contacts"
  | "sort-cards"
  | "auto-muck"
  | "jump-to-table"
  | "r2tgame"
  | "bbtournament"
  | "bbring"
  | "chips";
  valueRight?: string;
  children?: MenuItem[];
}

export const MAIN_MENU: MenuItem[] = [
  { id: "cashier", label: "Cashier", translation: "menu.option.cashier" },
  { id: "tx", label: "Transaction History", translation: "cashier.history" },
  {
    id: "gifts",
    label: "Promotions",
    translation: "menu.option.promotions",
    children: [
      {
        id: "bonuses",
        label: "Bonuses & Tickets",
        translation: "menu.option.bonusesTickets",
      },
      {
        id: "rakeback",
        label: "True Rakeback",
        translation: "menu.option.rakeback",
      },
      {
        id: "referfriend",
        label: "Refer a friend",
        translation: "menu.option.referFriend",
      },
    ],
  },
  { id: "shop", label: "Shop", translation: "menu.option.shop" },

  {
    id: "settings",
    label: "Settings",
    translation: "menu.option.settings",
    children: [
      {
        id: "settings-mute",
        label: "Mute sounds",
        translation: "menu.option.muteSound",
        type: "muteSound",
      },
      {
        id: "settings-theme",
        label: "Theme settings",
        translation: "menu.option.themeSettings",
      },
      {
        id: "settings-slider",
        label: "Slider shortcut buttons",
        translation: "menu.option.sliderShortcutButtons",
      },
      {
        id: "settings-r2t",
        label: "Run 2 Times (global)",
        translation: "menu.option.run2TimesGlobal",
        type: "r2t",
      },
      {
        id: "settings-lang",
        label: "Language",
        translation: "menu.option.language",
        type: "lang",
      },
    ],
  },

  {
    id: "profile",
    label: "Profile",
    translation: "menu.option.profile",
    children: [
      {
        id: "profile-hands",
        label: "Hand History",
        translation: "menu.option.handHistory",
      },
      {
        id: "profile-account",
        label: "Account Details",
        translation: "menu.option.editProfile",
      },
      {
        id: "profile-reset",
        label: "Reset Password",
        translation: "menu.option.resetPassword",
      },
      {
        id: "profile-selfex",
        label: "Self Exclude",
        translation: "menu.option.selfExclude",
      },
    ],
  },

  {
    id: "leaderboard",
    label: "Leaderboard",
    translation: "menu.option.leaderboard",
  },

  {
    id: "support",
    label: "Support",
    translation: "menu.option.support",
    children: [
      {
        id: "support-report",
        label: "Report an issue",
        translation: "menu.option.reportIssue",
      },
      {
        id: "contacts",
        label: "Contacts option",
        translation: "menu.option.supportContacts",
        type: "contacts",
      },
    ],
  },

  {
    id: "legal",
    label: "Legal",
    translation: "menu.option.legal",
    children: [
      {
        id: "legal-privacy",
        label: "Privacy Policy",
        translation: "menu.option.legalPrivacy",
      },
      {
        id: "legal-terms",
        label: "T&C",
        translation: "menu.option.legalTerms",
      },
      {
        id: "legal-responsible",
        label: "Responsible Gaming",
        translation: "menu.option.legalResponsible",
      },
    ],
  },
  {
    id: "logout",
    label: "Logout",
    translation: "menu.option.logout",
  },
];

export const TABLE_SETTINGS: MenuItem[] = [
  {
    id: "cards-display",
    label: "Cards Display",
    translation: "menu.option.cardsDisplay",
    children: [
      {
        id: "sort-cards",
        label: "Sort cards",
        translation: "menu.option.sortCards",
        type: "sort-cards",
      },
    ],
  },
  {
    id: "stack-display",
    label: "Stack Display",
    translation: "menu.option.stackDisplay",
    children: [
      {
        id: "stacks-bb-cash",
        label: "Stacks in BB (ring)",
        translation: "menu.option.stacksInBBRing",
        type: "bbring",
      },
      {
        id: "stacks-bb-tourn",
        label: "Stacks in BB (tournament)",
        translation: "menu.option.stacksInBBTournament",
        type: "bbtournament",
      },
    ],
  },
  {
    id: "gameplay",
    label: "Gameplay",
    translation: "menu.option.gameplay",
    children: [
      {
        id: "table-r2t",
        label: "Run it twice on this table",
        translation: "menu.option.tableR2t",
        type: "r2tgame",
      },
      {
        id: "auto-muck",
        label: "Auto muck",
        translation: "menu.option.autoMuck",
        type: "auto-muck",
      },
      // {
      //   id: "post-bb-auto",
      //   label: "Post big blind automatically",
      //   translation: "menu.option.postBbAuto",
      // },
    ],
  },
  // {
  //   id: "auto-rebuy",
  //   label: "Auto Rebuy",
  //   translation: "menu.option.autoRebuy",
  // },
  {
    id: "interface-experience",
    label: "Interface & Experience",
    translation: "menu.option.interfaceExperience",
    children: [
      {
        id: "mute-sound",
        label: "Mute Sound",
        translation: "menu.option.muteSound",
        type: "muteSound",
      },
      {
        id: "jump-to-table",
        label: "Jump to table",
        translation: "menu.option.jumpToTable",
        type: "jump-to-table",
      },
      {
        id: "chips",
        label: "Chips Display",
        translation: "menu.option.chips",
        type: "chips",
      },
      // {
      //   id: "swipe-table",
      //   label: "Swipe table",
      //   translation: "menu.option.swipeTable",
      // },
      // {
      //   id: "show-empty-seat",
      //   label: "Show empty seat",
      //   translation: "menu.option.showEmptySeat",
      // },
    ],
  },
];
